import triggerCustomGaEvent from '../analytics/triggerCustomGaEvent'

import _ from 'lodash'
import yn from 'yn'

export default function tripTeaseHotelRoomOffer(availability) {
	let ttRoomName = null,
			ttRoomId = null,
			ttRateId = null,
			ttRateName = null,
			ttRatePrice = null,
			ttRateCurrency = 'USD',
			lowestRoomRate = null

	// Search availability for up-sell rates to exclude from TT indexing
	let upSellRatePlanCodeData = []

	if (yn(process.env.REACT_APP_COMPONENT_TRIPTEASE_INCLUDE_UP_SELLS)) {
		for (const roomKey in availability.roomTypes) {
			const currentRoom = availability.roomTypes[roomKey]

			if (
				currentRoom &&
				currentRoom.viewExtensions &&
				currentRoom.viewExtensions.upsells &&
				!_.isEmpty(currentRoom.viewExtensions.upsells)
			) {
				for (const ratePlanKey in currentRoom.viewExtensions.upsells) {
					const currentUpSell = currentRoom.viewExtensions.upsells[ratePlanKey]

					upSellRatePlanCodeData.push(currentUpSell.ratePlanCode)
				}
			}
		}
	}

	// Filter out lowest room rate from availability
	if (!_.isEmpty(availability.roomTypes)) {
		let availableRoomRates = []

		for (const roomKey in availability.roomTypes) {
			const currentRoom = availability.roomTypes[roomKey]

			if (
				currentRoom.viewExtensions &&
				!_.isEmpty(currentRoom.viewExtensions.roomRates)
			) {

				for (const roomRateKey in currentRoom.viewExtensions.roomRates) {
					const currentRoomRate = currentRoom.viewExtensions.roomRates[roomRateKey]

					// Pull roomRates from each roomType that have a price and are not members type
					if (
						currentRoomRate &&
						!_.isEmpty(currentRoomRate.rates) &&
						_.get(currentRoomRate.rates, '[0].total.amountBeforeTax') &&
						currentRoomRate.ratePlanType !== 'MEMBER'
					) {
						availableRoomRates.push(currentRoomRate)
					}
				}
			}
		}

		// Filter available roomRates to find lowest by amountBeforeTax
		if (
			yn(process.env.REACT_APP_COMPONENT_TRIPTEASE_INCLUDE_UP_SELLS) &&
			upSellRatePlanCodeData &&
			!_.isEmpty(_.uniq(upSellRatePlanCodeData))
		) {
			// Filter out a unique set of uo-sell ratePlanCodes to exclude from TT indexing
			const excludedRatePlanCodes = _.uniq(upSellRatePlanCodeData)
			let modifiedRoomRates = []

			for (const rateKey in availableRoomRates) {
				modifiedRoomRates.push(availableRoomRates[rateKey])
			}

			// Remove all excluded up-sell roomRates from all availableRoomRates
			for (const ratePlanKey in excludedRatePlanCodes) {
				const currentRateCode = excludedRatePlanCodes[ratePlanKey]

				_.remove(modifiedRoomRates, {
					ratePlanCode: currentRateCode
				})
			}

			lowestRoomRate = _.minBy(modifiedRoomRates, 'rates[0].total.amountBeforeTax')
		} else {
			lowestRoomRate = _.minBy(availableRoomRates, 'rates[0].total.amountBeforeTax')
		}
	}

	if (
		lowestRoomRate &&
		!_.isEmpty(lowestRoomRate)
	) {
		// Map roomType and ratePlan data
		const lowestRoomType = availability.roomTypes.filter(function(roomTypes) {
						return roomTypes.roomTypeCode === lowestRoomRate.roomTypeCode
					}),
					lowestRatePlan = availability.ratePlans.filter(function(ratePlans) {
						return ratePlans.ratePlanCode === lowestRoomRate.ratePlanCode
					})

		if (_.get(lowestRoomType, '[0].roomDescription.name')) {
			ttRoomName = lowestRoomType[0].roomDescription.name
		}

		if (_.get(lowestRoomType, '[0].roomTypeCode')) {
			ttRoomId = lowestRoomType[0].roomTypeCode
		}

		if (lowestRoomRate.ratePlanCode) {
			ttRateId = lowestRoomRate.ratePlanCode
		}

		if (_.get(lowestRatePlan, '[0].ratePlanName')) {
			ttRateName = lowestRatePlan[0].ratePlanName
		}

		if (_.get(lowestRoomRate, 'rates[0].base.amountBeforeTax')) {
			ttRatePrice = lowestRoomRate.rates[0].base.amountBeforeTax
		}

		if (_.get(lowestRoomRate, 'rates[0].base.currencyCode')) {
			ttRateCurrency = lowestRoomRate.rates[0].base.currencyCode
		}

		const tripTeaseRoomOffer = {
			"@context": "http://schema.org/",
			"@type": "Offer",
			"itemOffered": {
				"@type": "HotelRoom",
				"name": ttRoomName ? ttRoomName.toString() : "",
				"identifier": ttRoomId ? ttRoomId.toString() : ""
			},
			"name": ttRateName ? ttRateName.toString() : "",
			"identifier": ttRateId ? ttRateId.toString() : "",
			"priceSpecification": {
				"@type": "UnitPriceSpecification",
				"price": ttRatePrice ? ttRatePrice.toString() : "",
				"priceCurrency": ttRateCurrency ? ttRateCurrency.toString() : ""
			}
		}

		triggerCustomGaEvent('triptease-hotel-room-offer', tripTeaseRoomOffer)
	}
}


// WEBPACK FOOTER //
// ./src/utilities/tripTease/tripTeaseHotelRoomOffer.js